export default "__VITE_PUBLIC_ASSET__fa4d67a7__"